import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsChipsModule } from '../chips/index';
import { RdsFilterOperatorHintPipeModule } from '../core/pipes/index';
import { RdsSortTextParameterOptionsPipe } from './sort-text-parameter-options.pipe';
import { RdsTextFiltersToChipsPipe } from './text-filter-chips.pipe';
import { RdsTextFilterComponent } from './text-filter.component';

const COMPONENTS = [RdsTextFilterComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    RdsChipsModule,
    RdsFilterOperatorHintPipeModule,
    ReactiveFormsModule,
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS, RdsTextFiltersToChipsPipe, RdsSortTextParameterOptionsPipe],
})
export class RdsTextFilterModule {}

export * from './text-filter.component';
export * from './text-filter.model';
